import React from "react";
import classes from './loadingSpinner.scss';
import { getLocalizedStrings } from "./loadingSpinnerLocalizedStrings";
const LoadingSpinner = (props) => {
    const strings = getLocalizedStrings('loadingSpinnerComponent');
    return (
        <div id='alert_section'>
            <div className={"row " + classes.loadingSpinnerOverlay}>
                <div className={"col-lg-10 " + classes.loadingSpinnerCard}>
                    <div className={classes.loaderMainHeader}>{props.loadingMainHeaderString ? props.loadingMainHeaderString: strings.weAreWorking}</div>
                    <div className={classes.borderBottom}>{""}</div>
                    <div className={classes.loadingSpinner}>
                        <div>{""}</div>
                        <div>{""}</div>
                        <div>{""}</div>
                        <div>{""}</div>
                    </div>
                    <span className={classes.loaderSubHeader}>{props.loaderSubHeaderString ? props.loaderSubHeaderString:strings.pleaseStandBy}</span>
                </div>
            </div>
        </div>
    );
};
export default LoadingSpinner;